<script lang="ts" setup>
defineProps({
   width: { type: String, default: '100%' },
   maxWidth: { type: String, default: '90%' },
   minWidth: { type: String, default: '30%' },
   height: { type: String, default: '1.5rem' },
   maxHeight: { type: String, default: '1.5rem' },
   minHeight: { type: String, default: '1.5rem' },

   randomWidth: { type: Boolean, default: false },
});

function randomNumber() {
   const randomNumber = Math.floor(Math.random() * (90 - 10)) + 30;
   return `${randomNumber}%`;
}
</script>

<template>
   <span :style="{ width: randomWidth ? randomNumber() : width, maxWidth, minWidth, height, maxHeight, minHeight }" class="skeleton-loader"
      >&nbsp;</span
   >
</template>

<style lang="scss" scoped>
.skeleton-loader {
   display: inline-block;
   border-radius: var(--border-radius);

   background: linear-gradient(90deg, lightgrey 0%, lightgrey 50%, rgb(237, 237, 237) 80%, lightgrey 100%);
   background-size: 250% 250%;
   animation: loading 1.5s infinite;

   opacity: 0.5;
}

// animated loading effect
@keyframes loading {
   0% {
      background-position: 150% 50%;
   }
   100% {
      background-position: 0 50%;
   }
}
</style>
